<template>
    <div class="d-flex justify-content-center my-5">
      <h1 class="center title">Recrutés</h1>
    </div>
    <div v-if="!showDetailsForm" class=" container d-flex justify-content-between flex-wrap" >
      <PostulCard :key="index" v-for=" (post , index) in this.posts " :post=post  @details="showDetails"  @refresh="getData" />
    </div>

   <DetailsPostVue v-if="showDetailsForm" @cancel="showDetails" :post="post"   @refresh="getData"/>
</template>

<script>
import axios from 'axios'
import APIs from "@/../config";
import PostulCard from "./components/postulation/PostulCard.vue"
import DetailsPostVue from './components/postulation/DetailsPost.vue';
export default {
    name: "Recrute",
    data() {
        return {
            addPost : false , 
            posts : [] , 
            post : {} , 
            showDetailsForm : false
        };
    },
    created() {
        this.getData()
    },
    methods: {
        showDetails(post){
            this.post = post
            this.showDetailsForm = !this.showDetailsForm
        },
        getData(){
            var get_token = localStorage.getItem('token')
            var user_id = localStorage.getItem('user_id')
          axios.get(`${APIs.API_URL}/cv/${user_id}` ,  {
                    headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${get_token}`
                    }
                })
          .then(res => {
            this.posts = res.data
            
          }).catch(error => {
              console.error(error)
          })
          this.showDetailsForm = false
        },
        AddAction(){
            this.addPost = !this.addPost
        },
        updateAction(post){
          this.showUpdateForm = !this.showUpdateForm
          this.toUpdate = post
        },
    },
    components: { PostulCard  , DetailsPostVue} 
}

</script>

<style scoped>



</style>


